import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import * as pdfjsLib from 'pdfjs-dist';
import { BackPreviewComponent } from '../public/public-preview/shared/component/back-preview/back-preview.component';
import { DialogLoginComponent } from '../public/public-preview/shared/component/dialog-login/dialog-login.component';
import { ImgViewerComponent } from './components/imgViewer.component';
import { MediaPlayerComponent } from './components/mediaPlayer.component';
import { PdfPasswordDialogComponent } from './components/pdfViewer-password-dialog';
import { PdfThumbComponent } from './components/pdfViewer-thumb.component';
import { PdfThumbListComponent } from './components/pdfViewer-thumbnails.component';
import { ResponseToQuestionComponent } from './components/response-to-question/response-to-question.component';
import { TxtViewerComponent } from './components/txtViewer.component';
import { UnknownFormatComponent } from './components/unknown-format/unknown-format.component';
import { ViewerMoreActionsComponent } from './components/viewer-more-actions.component';
import { ViewerOpenWithComponent } from './components/viewer-open-with.component';
import { ViewerSidebarComponent } from './components/viewer-sidebar.component';
import { ViewerToolbarActionsComponent } from './components/viewer-toolbar-actions.component';
import { ViewerToolbarComponent } from './components/viewer-toolbar.component';
import { ViewerComponent } from './components/viewer.component';
import { ViewerExtensionDirective } from './directives/viewer-extension.directive';
import { KeysPipe } from './shared/pipes/keys.pipe';
import { MaterialModule } from '../material.module';

//pdfjsLib.GlobalWorkerOptions.workerSrc = '/assets/pdf.worker.min.js';
//pdfjsLib.InvalidPDFException.disableFontFace = true;

@NgModule({
  imports: [
    FlexLayoutModule,
    MaterialModule
    
    
  ],
  declarations: [
    //PdfPasswordDialogComponent,
    ViewerComponent,
   // ImgViewerComponent,
   // TxtViewerComponent,
   // MediaPlayerComponent,
    PdfThumbComponent,
    PdfThumbListComponent,
    ViewerExtensionDirective,
    UnknownFormatComponent,
    ViewerToolbarComponent,
    ViewerSidebarComponent,
    ViewerOpenWithComponent,
    ViewerMoreActionsComponent,
    ViewerToolbarActionsComponent,
    BackPreviewComponent,
    //DialogLoginComponent,
    ResponseToQuestionComponent,
    KeysPipe,
   
  ],
  exports: [
    ViewerComponent,
   // ImgViewerComponent,
    //TxtViewerComponent,
   // MediaPlayerComponent,
    //PdfPasswordDialogComponent,
    PdfThumbComponent,
    PdfThumbListComponent,
    ViewerExtensionDirective,
    UnknownFormatComponent,
    ViewerToolbarComponent,
    ViewerSidebarComponent,
    ViewerOpenWithComponent,
    ViewerMoreActionsComponent,
    ViewerToolbarActionsComponent,
  ],
  providers: [{ provide: OWL_DATE_TIME_LOCALE, useValue: 'fr' }]
})
export class ViewerModule {
}
